/**
 * 現在のユーザー情報を管理するフック
 */

import { useState, useEffect } from 'react'
import apiClient from '@/shared/api/client'

/**
 * 現在のユーザー情報
 */
export interface CurrentUser {
    /** ユーザーID */
    id: string
    /** メールアドレス */
    email: string
    /** ユーザーロール */
    role: string
    /** テナントID */
    tenant_id: string
    /** 作成日時 */
    created_at: string
    /** 更新日時 */
    updated_at: string
}

/**
 * 現在のユーザー情報を取得・管理するフック
 */
export const useCurrentUser = () => {
    const [user, setUser] = useState<CurrentUser | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchCurrentUser = async () => {
            try {
                setLoading(true)
                setError(null)

                const response = await apiClient.get<CurrentUser>('/users/me')
                setUser(response.data)
            } catch (err: any) {
                console.error('Failed to fetch current user:', err)
                setError(err.response?.data?.message || 'ユーザー情報の取得に失敗しました')
                setUser(null)
            } finally {
                setLoading(false)
            }
        }

        fetchCurrentUser()
    }, [])

    return {
        user,
        loading,
        error,
        refetch: () => {
            setLoading(true)
            setError(null)
        }
    }
}
